export const Statuses = {
  OK: 'OK',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  PREFILLED: 'PREFILLED'
};
